<template>
  <div class="FooterBar">
    <div :class="footerTopClass">
      <div class="top-titile">
        <div class="title-item">
          <div class="item1" style="text-align: right">更美</div>
          <div class="item2" style="text-align: right">
            行业更美形象库场景库
          </div>
        </div>
        <div class="title-item">
          <div class="item1" style="text-align: center">更多</div>
          <div class="item2" style="text-align: center">
            行业更多数字人应用功能
          </div>
        </div>
        <div class="title-item">
          <div class="item1" style="text-align: left">更智能</div>
          <div class="item2" style="text-align: left">行业更快交互响应速度</div>
        </div>
      </div>
      <div class="top-btns">
        <div class="btn btn-apply" @click="openApplyDialog">
          免费试用
          <div class="btn-icon"></div>
        </div>
        <div class="btn btn-consult" @click="openContactDialog">
          立即咨询
          <div class="btn-icon"></div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="bottom-one">
        <div class="one-item">
          <div class="item-logo">
            <img :src="`${$CdnServerAddress}websit/web/logo.png`" />
          </div>
          <div class="item-content">
            客服电话：<a href="tel:400-105-1798">400-105-1798</a>
          </div>
          <div class="item-content">公司邮箱：bdbdigital@bdbdigital.com</div>
          <div class="item-content">
            地址：南京市浦口区江淼路88号腾飞大厦B座23层
          </div>
        </div>
        <div class="one-item">
          <div class="item-title">产品中心</div>
          <div class="item-content">
            <div @click="goToRouter('/yihua')">亿话</div>
          </div>
          <div class="item-content">
            <div @click="goToRouter('/yiying')">亿影</div>
          </div>
          <!-- <div class="item-content">
            <div @click="goToRouter('/yibo')">亿播</div>
          </div> -->
          <div class="item-content">
            <div @click="goToRouter('/jiaohu')">交互一体机</div>
          </div>
          <div class="item-content">
            <div @click="openWeb('https://yh.bdbdigital.com/')">亿话数字人智能体创作平台</div>
          </div>
        </div>
        <div class="one-item">
          <div class="item-title">解决方案</div>
          <div class="item-content">
            <div @click="goToRouter('/tourism')">数字文旅</div>
            <div @click="goToRouter('/model')">智能终端</div>
          </div>
          <div class="item-content">
            <div @click="goToRouter('/television')">广电融媒</div>
            <div @click="goToRouter('/customize')">定制服务</div>
          </div>
          <div class="item-content">
            <div @click="goToRouter('/exhibition')">展览展示</div>
            <div @click="goToRouter('/other')">其他行业</div>
          </div>
          <div class="item-content">
            <div @click="goToRouter('/teacher')">数字教师</div>
          </div>
        </div>
        <div class="one-item">
          <div class="item-title">关于我们</div>
          <div class="item-content">
            <div @click="goToRouter('/introduction#nd1Nne2R8QDSsDxB')">
              公司介绍
            </div>
            <!-- <div @click="goToRouter('/introduction#8SF8HYa1tAHaN7C2')">
              加入我们
            </div> -->
          </div>
          <div class="item-content">
            <div @click="goToRouter('/introduction#9cJKdZf2i56B4nnt')">
              开发者平台
            </div>
            <!-- <div @click="goToRouter('/introduction#B7SFAfEH5nE6sapN')">
              公司大事记
            </div> -->
            <!-- <div @click="goToRouter('/introduction#HBhG1ebcN4BxTZA4')">
              荣誉资质
            </div> -->
          </div>
          <div class="item-content">
            <div @click="goToRouter('/introduction#HBhG1ebcN4BxTZA4')">
              荣誉资质
            </div>
            <!-- <div @click="goToRouter('/introduction#9cJKdZf2i56B4nnt')">
              开发者平台
            </div> -->
            <!-- <div @click="goToRouter('/introduction#TNAAJKa7i0cPPwwD')">
              客户案例
            </div> -->
          </div>
          <div class="item-content">
            <div @click="goToRouter('/introduction#TNAAJKa7i0cPPwwD')">
              客户案例
            </div>
            <!-- <div @click="goToRouter('/introduction#0WMQpe9Ga1D6B8ss')">
              资讯动态
            </div> -->
          </div>
        </div>
        <div class="one-item">
          <div class="item-title">更多</div>
          <div class="item-content">
            <div @click="goToRouter('/cooperation')">代理合作</div>
          </div>
        </div>
      </div>
      <div class="bottom-two">
        <div class="two-item">
          本网站发布的所有内容，其知识产权归南京八点八数字科技有限公司或服务客户所有，未经授权任何个人和组织不得转载或使用
        </div>
        <div class="two-item">统一社会信用代码：913201053024494603</div>
        <div class="two-item">
          <a href="https://beian.miit.gov.cn/">苏ICP备15011620号-3</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/common/event-bus";

export default {
  name: "FooterBar",
  data() {
    return {
      footerTopClass: ["footer-top"],
    };
  },
  mounted() {
    if (location.pathname == "/") {
      this.footerTopClass = ["footer-top", "index"];
    } else {
      this.footerTopClass = ["footer-top"];
    }
  },
  methods: {
    openApplyDialog() {
      EventBus.$emit("openApplyDialog", { type: 1 });
    },
    openContactDialog() {
      EventBus.$emit("openContactDialog");
    },
    goToRouter(path) {
      location.href = path;
    },
    openWeb(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="less" scoped>
.FooterBar {
  color: #ffffff;
  position: relative;

  .footer-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("https://bdbcdn.bdbdigital.com/websit/web/bottom_pic.png")
      center no-repeat;
    background-size: cover;

    &.index {
      background: url("https://bdbcdn.bdbdigital.com/websit/web/bottom_pic_index.png")
        center no-repeat;
      background-size: cover;

      .top-titile {
        margin: 30px 0 80px;
      }

      .top-btns {
        margin-bottom: 240px;
      }
    }

    .top-titile {
      font-size: 64px;
      margin: 133px 0 80px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-item {
        margin-right: 150px;

        &:last-child {
          margin-right: 0;
        }

        .item1 {
          font-weight: bold;
          white-space: nowrap;
          margin-bottom: 40px;
        }

        .item2 {
          white-space: nowrap;
          font-size: 24px;
        }
      }
    }

    .top-btns {
      width: 320px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 133px;

      .btn {
        width: 134px;
        line-height: 38px;
        border: 1px solid #ffffff99;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background: #ffffff1a;
        }

        &.btn-apply {
          background: #a6000d;
          border-color: #a6000d;

          &:hover {
            background: #80000f;
            border-color: #80000f;
          }
        }

        .btn-icon {
          width: 16px;
          height: 16px;
          background: url("https://bdbcdn.bdbdigital.com/websit/web/arrow.svg")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .footer-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: url("https://bdbcdn.bdbdigital.com/websit/web/bottom_bg.png")
      no-repeat;
    background-size: 100% 100%;

    .bottom-one {
      width: 73%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin: 80px 0;

      .one-item {
        .item-logo {
          width: 148px;
          margin-bottom: 60px;

          img {
            width: 100%;
          }
        }

        .item-title {
          font-weight: bold;
          margin-bottom: 62px;
        }

        .item-content {
          font-size: 14px;
          color: #8c8c8c;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          &:last-child {
            margin-bottom: 0;
          }

          div {
            min-width: 70px;
            margin-right: 40px;
            cursor: pointer;

            &:hover {
              color: #ffffff;
            }

            &:last-child {
              margin-right: 0;
            }
          }

          a {
            color: #ffffff;
          }
        }
      }
    }

    .bottom-two {
      width: 73%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 40px;
      font-size: 14px;
      color: #8c8c8c;

      a {
        color: #8c8c8c;
        text-decoration: none;
      }
    }
  }

  .contact-dialog {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #00000080;
    display: flex;
    align-items: center;
    justify-content: center;

    .dialog-container {
      background: #000000;
      border-radius: 8px;
      overflow: hidden;

      .dialog-title {
        background: #141414;
        font-size: 24px;
        text-align: center;
        position: relative;
        line-height: 62px;

        .title-close-btn {
          width: 16px;
          height: 16px;
          position: absolute;
          top: 50%;
          right: 40px;
          transform: translate(0, -50%);
          background: url("https://bdbcdn.bdbdigital.com/websit/web/close.png")
            no-repeat;
          background-size: 100% 100%;
          cursor: pointer;
        }
      }

      .dialog-content {
        padding: 37px 215px 60px;

        .content-tips {
          font-size: 18px;
          text-align: center;
          line-height: 28px;
        }

        .content-wechat {
          width: 230px;
          height: 230px;
        }
      }
    }
  }
}
</style>